import {Button, Checkbox, Form, Input, Modal} from "antd";
import React, {useRef, useEffect, useState} from "react";
import Draggable from "react-draggable";
import { TicketViewModel } from "../../../../../../store/data/models/ticket-view-model";
import useFilters, {BaseFilters} from "../../../../../web-v2/hooks/useFilters";
import {useLazyGetUpdatesQuery} from "../../../../../../store/services/api/ticket-api";
import { CoreTable } from "../../../../components/CoreTable";
import {DataTable} from "react-native-paper";
import {Update} from "../../../../../../store/data/entities/update";
import {humanizeDate} from "../../../../../../utils/humanizers";
import UpdateTicketModal from "../../../../components/modals/UpdateTicketModal";
import useUser from "../../../../../../hooks/useUser";


interface TicketUpdatesListModalModalProps {
  ticket?: TicketViewModel;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

interface TicketsListFilters extends BaseFilters {
  ticketId: string;
}

export default function TicketUpdatesListModal(props: TicketUpdatesListModalModalProps) {
  
  if (!props.ticket) return null;
  const [updateTicketModalOpen, setUpdateTicketModalOpen] = useState(false);
  const [getUpdates, {data, isFetching}] = useLazyGetUpdatesQuery();
  const loadTable = (filters?: Record<string, any>) => getUpdates(filters ?? getFilterValues());

  const filter = useFilters<TicketsListFilters>({
    ticketId: props.ticket?.id ?? "",
    pageNumber: 1,
    pageSize: 10,
    sortedColumn: "dateCreated",
    sortedColumnAscending: false
  }, loadTable);
  const {getFilterValues, filters, setFilter} = filter;

  useEffect(() => {
    loadTable();
  }, [props.ticket.id]);



  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
    const resetToCenter = () => {
    setPosition({ x: 0, y: 0 });
  };
  const {user} = useUser();
  const canEdit =  user?.role !== 'ViewOnly';
  
  return (
    <>

      <Modal
        open={props.open}
        title={
          <div
            style={{ cursor: "move", width: "100%" }}
            onMouseOver={() => disabled && setDisabled(false)}
            onMouseOut={() => setDisabled(true)}
          >
            Ticket Updates
          </div>
        }
        destroyOnClose
        centered={false}
        width={600}
        onCancel={props.onClose}
        footer={[
          <Button key="cancel" onClick={props.onClose}>
            Close
          </Button>,

          <Button
            key="save"
            type="primary"
            disabled={!canEdit}
            onClick={() => setUpdateTicketModalOpen(true)}
          >
            Add Update
          </Button>,
        ]}

        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            nodeRef={draggleRef}
            defaultPosition={{ x: 0, y: 0 }}
            onStart={() => setIsDragging(true)}
            onStop={(e, data) => {
              setIsDragging(false);
            }}
          >
            <div
              ref={draggleRef}
              style={{
                willChange: "transform",
                pointerEvents: isDragging ? "none" : "auto",
              }}
            >
              {modal}
            </div>
          </Draggable>
        )}
        >
          <CoreTable<any>
            filters={filters}
            setFilter={setFilter}
            isLoading={isFetching}
            keyExtractor={(item) => item.id}
            data={data}
            headers={[
              {text: 'Date',  flex: 0.2},
              {text: 'Description'},
            ]}
            renderItem={({ item, index, headers }) => (
              <CoreTable.Row key={item.id}>
                <CoreTable.Cell style={{flex: 0.2}}>{humanizeDate(item.dateCreated)}</CoreTable.Cell>
                <CoreTable.Cell >{item.text}
                </CoreTable.Cell>
              </CoreTable.Row>
            )}
          />        
      </Modal>
      <UpdateTicketModal
       ticket={props.ticket}
       open={updateTicketModalOpen}
       onClose={() => {setUpdateTicketModalOpen(false); loadTable();}} />

      {/* <FollowUpWorkOrderModal
        parentWorkOrderId={props.workOrderId}
        onSuccess={handleWorkOrderCreation}
        assetId={asset?.assetId}
        assetLabel={asset?.assetDescription}
        visible={workOrderModalVisible}
        onClose={() => setWorkOrderModalVisible(false)}
      /> */}
    </>
  )
}
